import React from 'react';

import PageLayout from '../../components/layout/PageLayout';
import Dashboard from '../../components/dashboard/Dashboard';

const DashboardPage = () => (
  <PageLayout>
    <Dashboard />
  </PageLayout>
);

export default DashboardPage;
